import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { Calendar, DateObject } from 'react-multi-date-picker';

import { gregorian_ru } from 'utils/dates';

import { getFormatDates, getFormatToDate } from './utils';

type Props = {
  onChange: (dates: string[]) => void;
  value: string[];
  currentDate: string;
};

const SchedulerComponent: FC<Props> = ({ onChange, value, currentDate }) => {
  const calendarRef = useRef<any>();

  const [dates, setDates] = useState<DateObject[] | undefined>([]);

  useEffect(() => {
    setDates(getFormatToDate(value));
  }, [value]);

  const defaultDate = useMemo(() => new Date(currentDate), [currentDate]);

  useEffect(() => {
    let date = calendarRef.current?.date;
    if (calendarRef) {
      calendarRef.current?.set('month', (date['month'] = defaultDate.getMonth() + 1));
      calendarRef.current?.set('year', (date['year'] = defaultDate.getFullYear()));
    }
  }, [currentDate, defaultDate]);

  const onChangeCalendarHandler = (dates: DateObject | DateObject[] | null) => {
    onChange(getFormatDates(dates as DateObject[]));
  };

  const currentDateObject = useMemo(
    () =>
      new DateObject({
        year: defaultDate.getFullYear(),
        month: defaultDate.getMonth() + 1,
        day: 1,
      }),
    [defaultDate],
  );

  return (
    <div>
      <Calendar
        ref={calendarRef}
        multiple
        value={dates}
        onChange={onChangeCalendarHandler}
        locale={gregorian_ru}
        weekStartDayIndex={1}
        currentDate={currentDateObject}
        buttons={false}
        hideMonth
        hideYear
        highlightToday={false}
      />
    </div>
  );
};

export default SchedulerComponent;
